<template>
    <div v-if="projectLogoSchema">
        <div class="logo">
            <img :src="projectLogoSchema.project_logo" v-on:click="openLogoForm" alt="">
        </div>

        <!-- модалка Загрузить файл -->
        <div v-if="changeForm" class="modal fade show project-show" id="upload-file">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <button type="button" class="close" v-on:click="closeLogoForm">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div class="upload-block">
                        <div class="upload-block">
                            <picture-input
                                    ref="pictureInput"
                                    @change="onChanged"
                                    @remove="onRemoved"
                                    :width="200"
                                    :removable="true"
                                    removeButtonClass="logo-input-button"
                                    :height="200"
                                    accept="image/jpeg, image/png, image/gif"
                                    buttonClass="logo-input-button"
                                    :customStrings="{
                                upload: '<h1>Upload it!</h1>',
                                drag: projectLogoSchema.massages.downloadArea
                            }">

                            </picture-input>
                            <div class="title-com">
                                <div class="title">
                                    {{projectLogoSchema.massages.download}}
                                </div>
                                <div class="com">
                                    {{projectLogoSchema.massages.size}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="loaded-logos">
                        <a v-for="(userLogo, key) in projectLogoSchema.user_logos" href="javascript:void(0)"
                           v-on:click="setActive(userLogo, key)"
                           :class="activeIndex == key ? 'one-logo active' : 'one-logo'">
                            <img :src="userLogo.src" alt="">
                        </a>
                    </div>
                    <div class="btns-wrap">
                        <a href="javascript:void(0)" class="btn-std btn" v-on:click="saveProjectLogo">
                            {{projectLogoSchema.massages.save}}
                        </a>
                        <a href="javascript:void(0)" class="btn-gray btn" v-on:click="closeLogoForm">
                            {{projectLogoSchema.massages.cancel}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!-- конец модалка Загрузить файл -->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import PictureInput from 'vue-picture-input';
    import axios from 'axios';

    /**
     * Компонент для изменения логотипа проекта
     *
     *  - projectLogoSchema - данные с бэка с учетом языка
     *  <picture-input> - инпут для изменения лого
     *
     * @vuedoc
     * @module vue:components/ProjectLogo
     * @exports vue:components/ProjectLogo
     */
    export default {
        name: "project-logo",

        props: ['project_id'],

        components: {
            'picture-input': PictureInput
        },

        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {boolean} isRename - Флаг, активна ли возможность изменения названия проекта
         * @property {string} projectName - Название проекта
         */
        data() {
            return {
                changeForm: false,
                projectName: "",
                activeIndex: undefined,
                projectLogo: ""
            }
        },

        computed: {

            ...mapGetters('project', [
                'projectLogoSchema'
            ]),
        },

        mounted() {
            this.$store.dispatch('project/getProjectLogoSchema', this.project_id);
        },

        methods: {

            /**
             *  Модалька загрузки лого
             *
             * @method changeLogo
             */
            openLogoForm() {
                this.changeForm = true;
            },

            closeLogoForm() {
                this.changeForm = false;
            },


            /**
             *  Изменяет логотип проекта
             *
             * @method saveProjectLogo
             */
            saveProjectLogo() {
                if (this.projectLogo) {
                    this.$store.dispatch('project/changeProjectLogo', {
                        "projectId": this.project_id,
                        "newProjectLogo": this.projectLogo
                    });
                }
                this.changeForm = false;
            },

            onChanged() {
                if (this.$refs.pictureInput.file) {
                    this.projectLogo = this.$refs.pictureInput.file;
                    this.attemptUpload();
                } else {
                    console.log("Old browser. No support for Filereader API");
                }
            },
            onRemoved() {
                this.image = '';
            },
            attemptUpload() {
                const formData = new FormData();
                formData.append(this.projectLogo.name, this.projectLogo);
                formData.append("handler", "projects");
                formData.append("func", "addUserLogo");
                formData.append("projectId", this.project_id);
                if (this.projectLogo) {
                    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data' // for POST requests
                    axios.post('/ajax/common.php', formData, {
                        headers: {
                            'Content-Type' : 'multipart/form-data'
                        }
                    }).then(response => {
                        this.projectLogo = response.data.data.projectLogoSchema.project_logo;
                        this.$store.dispatch('project/getProjectLogoSchema', this.project_id);
                    })
                        .catch(err => {
                            console.error(err);
                        });
                }
            },
            setActive(logo, index) {
                this.activeIndex = index;
                this.projectLogo = logo.src
            },
        }
    }


</script>